import { AiFillPieChart, AiOutlineBarChart } from 'react-icons/ai'
import { RiBarChartHorizontalFill } from 'react-icons/ri'
import React from 'react'

export function insertNodeById(tree, id, newNode) {
  if (!tree || !newNode) {
    return // Invalid inputs
  }

  // Recursive function to traverse the tree and find the node with the matching id
  function traverseAndInsert(node) {
    if (node.id === id) {
      if (!node.children) {
        node.children = []
      }
      node.children.push(newNode)
      return true // Node found and new node inserted
    }

    if (node.children) {
      for (const child of node.children) {
        if (traverseAndInsert(child)) {
          return true // Node found and new node inserted in child
        }
      }
    }

    return false // Node not found in this subtree
  }

  traverseAndInsert(tree) // Start traversal from the root
}

export const renderIcon = icon => {
  switch (icon) {
    case 'column':
      return <AiOutlineBarChart />
    case 'bar':
      return <RiBarChartHorizontalFill />
    case 'circle':
      return <AiFillPieChart />
    default:
      return <AiOutlineBarChart />
  }
}
